<template>
    <div class="table-responsive bg-white rounded-3 mb-0 mt-4">
        <BTable 
            id="my-table" 
            :items="data" 
            :fields="header"
            :per-page="perPage"
            :current-page="currentPage">
            <template #cell(no)="data">
                {{ data.index + 1 }}
            </template>
            <template #cell(is_online)>
                <i class="fas fa-circle" style="color: #38c41c;"></i>
            </template>
            <template #cell(type_room)="props">
                <BBadge
                    class="badge-type-room"
                    :bg-variant="getBadgeTypeRoom(props.item.type_room)"
                >
                    {{ props.item.type_room }}
                </BBadge>
            </template>
            <template #cell(status_room)="props">
                <BBadge
                    class="badge-status-room"
                    :bg-variant="getBadgeStatusRoom(props.item.status_room.key)"
                >
                    <img width="16" :src="props.item.status_room.icon" alt="">
                    {{ props.item.status_room.label }}
                </BBadge>
            </template>
            
            <template #cell(status_maintenance)="props">
                <BBadge
                    class="badge-status-maintenance"
                    :bg-variant="getBadgeStatusMaintenance(props.item.status_maintenance)"
                >
                    {{ props.item.status_maintenance }}
                </BBadge>
            </template>
            <template #cell(status_reservation)="props">
                <span
                    :class="`badge badge-status text-${getBadgeStatusReservation(props.item.status_reservation.key)} border border-${getBadgeStatusReservation(props.item.status_reservation.key)}`"
                >
                    {{ props.item.status_reservation.label }}
                </span>
            </template>

            <template #head(warehouse)="props">
                <span
                   
                >
                    <i class="fas fa-warehouse"></i>
                    {{ props.label}}
                    
                </span>
            </template>
            <template #head(room)="props">
                <span
                   
                >
                    <i class="fas fa-door-open"></i>
                    {{ props.label}}
                    
                </span>
            </template>
            <template #head(defact)="props">
                <span
                   
                >
                    <i class="fas fa-fill-drip"></i>
                    {{ props.label}}
                    
                </span>
            </template>
            <template #thead-top>
                <slot name="thead-top"></slot>
            </template>
            <template #cell(action)="props">
                <div class="d-flex justify-content-center">
                    <BButton
                        v-for="(action, index) in customActions"
                        :key="index"
                        :variant="getButtonVariant(props.item, action)"
                        @click="handleAction(props.item, action)"
                        :title="action.label"
                        v-tooltip="action.label"
                        :disabled="handleDisabledAction(props.item, action)"
                        class="mx-1"
                        
                    >
                        <i :class="`${action.icon} text-white`"></i>
                    </BButton>
                    <div v-if="detail" class="dropright">
                        <BButton class="btn btn-light mx-2" data-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-ellipsis-v"></i>
                        </BButton>
                        <div class="dropdown-menu dropdown-menu-right">
                        <a href="" class="dropdown-item-text">Detail</a>
                        </div>
                    </div>
                </div>
            </template>
            
        </BTable>
    </div>
    <div class="pagination d-lg-flex d-flex align-items-center justify-content-between bg-white rounded-3">
        <div class="d-lg-flex d-flex align-items-center p-4">
            <div class="pagination-option">
                <BFormSelect v-model="perPage" :options="options" class="">
                </BFormSelect> 
            </div>
            <div class="pagination-text">
                <span class="ms-2" style="white-space: nowrap">Showing {{ (currentPage - 1) * perPage + 1 }} to {{ (currentPage * perPage, data.length) }}
                    of {{ data.length }}              
                </span>
            </div>
        </div>
        <div class="w-25 p-4">
            <BPagination
                v-model="currentPage"
                :total-rows="data.length"
                :per-page="perPage"
                aria-controls="my-table"
                class="mb-0 justify-content-end">
    
            </BPagination>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { BTable, BPagination, BFormSelect, BButton, BBadge } from "bootstrap-vue-next";

export default{
    name: 'DataTable',
    components: {
        BTable,
        BPagination,
        BFormSelect,
        BButton,
        BBadge,
    },
    props: {
        data: Array,
        header: Array,
        rows: Number,
        customActions: Array,
        detail: {
            type: Boolean,
            default: false
        }
    },
    setup(){
        const perPage = ref(10)
        const currentPage = ref(1)
        const options = ref([
            
            {
                text: '10',
                value: 10,
            },
            {
                text: '25',
                value: 25,
            },
            {
                text: '50',
                value: 50,
            },
        ])
        const getBadgeTypeRoom = (type) => {
        switch (type) {
            case 'Deluxe': return 'danger';
            case 'Super Deluxe': return 'light';
            case 'Family': return 'orange';
            case 'Studio': return 'success';
            case 'Honeymoon': return 'primary';
            default: return '';
        }
        };
        const getBadgeStatusReservation = (status) => {
        switch (status) {
            case 'checkin': return 'primary';
            case 'checkout': return 'orange';
            case 'checkout_on': return 'purple';
            case 'inhouse': return 'warning';
            case 'booked': return 'success';
            case 'available': return 'secondary';
            case 'void': return 'danger';
            default: return '';
        }
        };
        const getBadgeStatusRoom = (key) => {
        switch (key) {
            case 'available': return 'light';
            case 'reserved': return 'success';
            case 'checkout': return 'orange';
            case 'inhouse': return 'warning';
            case 'checkin': return 'primary';
            case 'under_maintenance': return 'danger';
            case 'in_cleaning': return 'secondary';
            case 'dirty': return 'purple';
            default: return '';
        }
        };
        const getBadgeStatusMaintenance = (key) => {
        switch (key) {
            case 'Under Maintenance': return 'success';
            default: return 'danger';
        }
        };
        const getButtonVariant = (item, action) =>  {
            if (item.start_time !== '-' && item.end_time === '-') {
                return 'danger'; 
            }
            if (action.label === 'Payment' && item.status_payment === 'DP'
                || action.label === 'Check In' && item.status_payment === 'DP'
                || action.label === 'Update' && item.status_maintenance === 'Maintenance Completed'
                || item.status_cleaning ==='finish' ) {
                return 'secondary'; 
            }
            return action.variant;
        }
        const handleAction = (item, action) => {
            action.action(item);
        };
        const handleDisabledAction = (item, action) => {
            if (action.label === 'Payment' && item.status_payment === 'DP' || action.label === 'Check In' && item.status_payment === 'DP') {
                return true; // Disable button
            }
            if (action.label === 'Finish' && item.status_cleaning === 'finish') {
                return true; // Disable button
            }
            if (action.label === 'Update' && item.status_maintenance === 'Maintenance Completed') {
                return true; // Disable button
            }
            return false;
        }
        return{
            perPage,
            options,
            currentPage,
            getBadgeTypeRoom,
            getBadgeStatusReservation,
            getBadgeStatusRoom,
            getButtonVariant,
            getBadgeStatusMaintenance,
            handleAction,
            handleDisabledAction
        }
    }
}

</script>

<style>

@media screen and (max-width: 576px) {
    .pagination-option select{
        line-height: 1.25rem;
    }
    .pagination-option option{
        font-size: 0.95rem;
    }
    .pagination-text {
        font-size: 0.85rem;
    }
    .page-item .page-link{
        font-size: 0.75rem;
    }
}

</style>